$(function () {
    'use strict';

    $("[data-switch='1']").bootstrapSwitch({
        labelWidth: 0
    });

    $('.checkbox-custom').checkbox();

    $('.js-date').datetimepicker({
        locale: 'ru'
    });

    treefilter($('.segments-tree'),{
        searcher: "#search-segments",
        info: ".segments-info",
        multiselect: true
    });

    $(".tree-control").resizable({
        handles: "s",
        minHeight: 100
    });

    // hide text menu
    var hideTextMenu = {
        events: function() {
            var that = this;

            $(window).resize(function(){
                that.windowWidth = $(window).width();
                that.maxWidth = that.windowWidth - that.offsetMenu - that.widthUserMenu;
                if(that.widthMenu > that.maxWidth) {
                    $(".base-menu").addClass("base-menu_compact");
                } else {
                    $(".base-menu").removeClass("base-menu_compact");
                }

                // console.log(that.maxWidth, that.widthMenu, that.widthUserMenu)
            }).resize();
        },

        init: function() {
            var that = this;
            that.widthMenu = $(".base-menu").outerWidth();
            that.offsetMenu = 280;
            that.widthUserMenu = $(".navbar-nav.navbar-right").outerWidth() + 40;

            that.events();

            $(".base-menu").addClass("base-menu_init");
        }
    }
    setTimeout(function(){
        hideTextMenu.init();
    }, 100);
    
    // edit item table
    // documentation http://www.appelsiini.net/projects/jeditable
    $('.js-edit').each(function() {
        var self = $(this),
            url = self.data('jeditable-url'),
            id = self.data('jeditable-id'),
            params = self.data('jeditable-params') || {},
            original_value = '--';

        self.editable(function(value, settings) {
            $.ajax({
                url: url,
                dataType: 'json',
                method: 'post',
                data: {
                    value: value,
                    id: id,
                    params: params
                },
                beforeSend: function () {
                    original_value = self.attr('value');
                },
                error: function () {
                    self.text(original_value);
                },
                success: function(response) {
                    if (response && response.success) {
                        self.text(response.value).attr('value', response.value);
                    } else {
                        self.text(original_value);
                        if (response.error) {
                            INTENT.utils.Notify.error(response.error);
                        }
                    }
                }
            });

            return '<i class=\"fa fa-circle-o-notch fa-spin\"></i>';
        });
    });

    //table sort
    $('[data-table-sortable]').tablesort();

    // custom dropdown table

    $('.table .dropdown.table-colored__menu [data-toggle = "dropdown"]').on('click', function(){
        var browsWidth = $(window).width(),
            dropdown = $(this).next(".dropdown-menu"),
            dropdownWidth = dropdown.outerWidth(),
            btnWidth = $(this).width(),
            btnHeight = $(this).height(),
            btnCenter = btnWidth / 2,
            top = $(this).position().top + btnHeight + 10, // 10 height triangle
            left = ($(this).position().left - 30) + (btnCenter - 10), // align the triangle in the middle btn
            right = browsWidth - (left + dropdownWidth);
            
            if(right < dropdownWidth) {
                left = ($(this).position().left + 20) + (btnCenter + 10) - (dropdownWidth);
                dropdown.addClass('position-right');
            } else {
                dropdown.removeClass('position-right');
            }

            dropdown.css({
                "top": top,
                "left": left
            });
    });

    // toggle sidebar
    var toggleMenu = {
        showMenu: function() {
            $(".sidebar a").tooltip('destroy');
            $(".sidebar").addClass("sidebar_state_open");
            $(".wrap").addClass("wrap_show_sidebar");
            this.stateMenu = "show";

            Cookies.set('stateMenu', 'open', { expires: 7 });
        },

        hideMenu: function() {
            $(".sidebar a").tooltip();
            $(".sidebar").removeClass("sidebar_state_open");
            $(".wrap").removeClass("wrap_show_sidebar");
            this.stateMenu = "close";

            Cookies.set('stateMenu', 'close', { expires: 7 });
        },

        init: function() {
            var that = this;
            that.stateMenu = "close";

            if(Cookies.get('stateMenu') == "open") {
                that.showMenu();
            }

            $(".js-sidebar-show").on("click", function(e) {
                e.preventDefault();

                if(that.stateMenu == "close") {
                    that.showMenu();
                } else {
                    that.hideMenu();
                }
            });

            setInterval(function(){
                $(".sidebar").addClass("js-init-menu");
                $(".wrap").addClass("js-init-menu");
            }, 100);
        }
    }

    if($(".sidebar .nav").length > 0) {
        toggleMenu.init();
    }


    // fix для fixed menu при горизонтальном скроле
    $(window).scroll(function(){
        if($(window).scrollLeft() > 0) {
            $(".sidebar__inner").css('left', - $(window).scrollLeft());
        } else {
            $(".sidebar__inner").css('left', "");
        }
    });
});